// Small formatting helpers used across pages.

export function relativeTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const now = Date.now();
  const diff = Math.round((now - d.getTime()) / 1000);
  if (diff < 5) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return `${Math.round(diff / 86400)}d ago`;
}

export function fmtDuration(secs) {
  if (secs == null) return "—";
  if (secs < 1) return `${(secs * 1000).toFixed(0)} ms`;
  if (secs < 60) return `${secs.toFixed(1)} s`;
  const m = Math.floor(secs / 60);
  const s = Math.floor(secs - m * 60);
  return `${m}m ${s}s`;
}

export function fmtBytes(b) {
  if (b == null) return "—";
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(1)} MB`;
  return `${(b / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function fmtNum(n) {
  if (n == null) return "—";
  if (Number.isInteger(n)) return n.toString();
  if (Math.abs(n) < 0.001 || Math.abs(n) > 1e6) return n.toExponential(3);
  return Number(n).toFixed(3);
}

export function shortId(id, n = 8) {
  if (!id) return "";
  return id.length > n ? `${id.slice(0, n)}…` : id;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke later so the click has time to register.
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
